const isMiniProgram = async () => {
    if (/MicroMessenger/i.test(navigator.userAgent)) {
        function isMp() {
            return new Promise((resolve, reject) => {
                wx.miniProgram.getEnv(function (res) {
                    if (res.miniprogram) {
                        resolve(true)
                    } else {
                        resolve(false)
                    }
                })
            })
        }
        let result = await isMp();
        return result;
    } else {
        return false;
    }
};
const switchTab = (opt) => {
    wx.miniProgram.switchTab({
        url: opt.url,
        fail: (res) => {
            navigateTo(opt)
        }
    })
}
const navigateTo = (opt) => {
    wx.miniProgram.navigateTo({
        url: opt.url,
        fail: (res) => {
            switchTab(opt)
        }
    })
}
const redirectTo = (opt) => {
    wx.miniProgram.redirectTo({
        url: opt.url
    })
}
const reLaunch = (opt) => {
    wx.miniProgram.reLaunch({
        url: opt.url
    })
}
const postMessage = (data) => {
    wx.miniProgram.postMessage({ data: data })
}
const navigateBack = (data={}) => {
    wx.miniProgram.navigateBack(data)
}

let mp = {
    isMiniProgram: isMiniProgram,
    navigateTo: navigateTo,
    postMessage: postMessage,
    navigateBack: navigateBack,
    redirectTo: redirectTo,
    reLaunch: reLaunch,
    switchTab: switchTab,
}

export const miniProgram = mp;



// WEBPACK FOOTER //
// ./src/utils/miniProgram.js